import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import NotificationHome from "./components/Notifications";

const Information = () => {
	return (
		<>
			<Sidebar />
			<MainSection>
				<SectionHeader title="More Information" />
				<NotificationHome />
			</MainSection>
		</>
	);
};

export default Information;
